/**
 * Tells the person when someone starts editing in a project they watch (utils/watchModel.js): after every `/api/v1/live`
 * poll, an in-app notification (and a browser one when allowed and the tab is hidden). Mounted once, by the sidebar.
 */
import { notification } from 'antd';
import { useLiveAnswer } from './useLiveNow';
import { startedEditing, startedText, watchedProjects } from '../utils/watchModel';

export default function useWatchNotifications(onOpen) {
  useLiveAnswer((answer, previous) => {
    if (!previous) { return; } // the first answer is how things are, not a change
    const watched = watchedProjects();
    if (watched.length === 0) { return; }
    startedEditing(previous, answer, watched).forEach((entry) => {
      const text = startedText(entry);
      notification.info({
        key: `watch:${entry.projectId}`,
        message: text,
        description: 'You are watching this project.',
        onClick: () => onOpen?.(entry.projectId),
        placement: 'bottomRight',
      });
      try {
        if (typeof Notification !== 'undefined' && Notification.permission === 'granted' && document.visibilityState === 'hidden') {
          // eslint-disable-next-line no-new
          new Notification('Flow', { body: text, tag: `watch:${entry.projectId}` });
        }
      } catch { /* not available */ }
    });
  });
}
